import { Box, Divider } from "@origin-digital/ods-core";
import { Skeleton } from "@origin-digital/ods-lab";

const SkeletonTile = ({ dataId }: { dataId: string }) => (
  <Box>
    <Box
      display="flex"
      width="full"
      flexDirection="row"
      alignItems="flex-start"
      gap="small"
      data-id={dataId}
      marginBottom="medium"
    >
      <Box paddingY="xxxsmall">
        <Skeleton width={20} height={30} backgroundColor="light" />
      </Box>
      <Box width="full">
        <Skeleton
          height={35}
          variant="text"
          width="50%"
          backgroundColor="light"
        />
        <Skeleton variant="text" width="100%" backgroundColor="light" />
        <Skeleton variant="text" width="50%" backgroundColor="light" />
      </Box>
    </Box>
    <Divider />
  </Box>
);

export const ArticleSkeleton = () => {
  return (
    <Box display="flex" width="full" gap="xsmall" flexDirection="column">
      <SkeletonTile dataId="article-skeleton-tile-1" />
      <SkeletonTile dataId="article-skeleton-tile-2" />
      <SkeletonTile dataId="article-skeleton-tile-3" />
    </Box>
  );
};
